import React, { FunctionComponent, useMemo } from 'react';
import { useTranslation } from '@rbx/intl';
import TopNavigationDropdownTabMenu, {
  TNavigationDropdownItem,
} from './TopNavigationDropdownTabMenu';
import { getLocalizedDropdownLink } from '../../utils/getLocalizedDropdownLink';
import { NavigationTab } from '../constants/navigationConstants';
import TopNavigationDropdownDrawerMenu from './TopNavigationDropdownDrawerMenu';
import useNavigationConfigs from '../../hooks/useNavigationConfigs';

export type TNavigationDropdownData = {
  items: TNavigationDropdownItem[][];
};

export const validateDropdownData = (data: TNavigationDropdownData) => {
  try {
    const { items } = data;
    items.flat().forEach((item) => {
      if (item.path === undefined || item.path === null || !item.title) {
        throw Error;
      }
    });
    return true;
  } catch {
    return false;
  }
};

interface TopNavigationDropdownTabContentDocSiteProps {
  tab: NavigationTab;
}

const TopNavigationDropdownTabContentDocSite: FunctionComponent<
  TopNavigationDropdownTabContentDocSiteProps
> = ({ tab }) => {
  const { translate } = useTranslation();
  const { isCompact } = useNavigationConfigs();
  const { enableCourses } = useNavigationConfigs();

  const translatedItems = useMemo(() => {
    const menuData = [
      [
        {
          translationKey: 'Label.Overview',
          path: '/',
        },
        {
          translationKey: 'Label.Create',
          path: '/platform',
        },
        {
          translationKey: 'Label.Scale',
          path: '/scale',
        },
        {
          translationKey: 'Label.Monetize',
          path: '/monetize',
        },
      ],
      [
        {
          translationKey: 'Label.EngineReference',
          path: '/reference/engine',
        },
        {
          translationKey: 'Label.OpenCloudReference',
          path: '/cloud',
        },
      ],
      ...(enableCourses
        ? [
            [
              {
                translationKey: 'Label.Courses',
                path: `/courses`,
              },
            ],
          ]
        : []),
    ];

    return menuData.map((submenu) =>
      submenu.map((item) => ({
        path: getLocalizedDropdownLink({
          currentPath: typeof window !== 'undefined' ? window.location.pathname : '',
          itemPath: item.path,
        }),
        title: translate(item.translationKey),
      })),
    );
  }, [translate, enableCourses]);

  if (isCompact) {
    return <TopNavigationDropdownDrawerMenu translatedItems={translatedItems} tab={tab} />;
  }

  return <TopNavigationDropdownTabMenu items={translatedItems} />;
};

export default TopNavigationDropdownTabContentDocSite;
